import styled from 'styled-components';

import { PADDING_CONTENT_PAGE, FONT_SIZE_TITLE_TOP, COLOR_NUMBER_TITLE_TOP } from '../../../globals';


export const StyledTitleTop = styled.h1`
  padding: 10px ${PADDING_CONTENT_PAGE}px 6px ${PADDING_CONTENT_PAGE}px;
  font-size: ${FONT_SIZE_TITLE_TOP}em;
  font-weight: bold;

  .title-top-num {
    color: ${COLOR_NUMBER_TITLE_TOP};
  }

  .title-top-title {
    
  }
}
`;
